<template>
  <div class="club-menu">
    <div class="tabs">
      <template v-for="(item, index) in items">
        <input
          :key="`input-${index}`"
          type="radio"
          :id="`menu-item-${index}`"
          :value="index"
          v-model="activeTab"
          @change="goToRoute(item, index)" />
        <label
          :key="`label-${index}`"
          class="tab"
          :for="`menu-item-${index}`">
          <v-icon small>{{ item.icon }}</v-icon>
          <span class="tab-label">{{ item.name }}</span>
          <h4
            v-if="$store.state.clubMember.rol !== 'MEMBER' && item.route === '/club/members' && pendingMembers > 0"
            class="badge text-center ml-2 mb-0"
          >
            {{ (pendingMembers > 9)? '+9' : pendingMembers }}
          </h4>
        </label>
      </template>
      <span class="glider" :style="gliderStyle"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClubMenu",
  data() {
    return {
      pendingMembers: 0,
      activeTab: 0,
      items: []
    };
  },
  watch: {
    '$store.state.clubMembers': function () {
      this.seePendingRequests();
    },
    '$route.path': {
      immediate: true,
      handler() {
        this.setActiveTabFromRoute();
      }
    }
  },
  computed: {
    gliderStyle() {
      const primaryColor = this.$store.state.clubMember?.club?.primaryColor;
      const backgroundColor = primaryColor ? `#${primaryColor}` : '#009F63';
      const tabCount = this.items.length || 1;
      const widthPercentage = 100 / tabCount;

      return {
        transform: `translateX(${this.activeTab * 100}%)`,
        backgroundColor: backgroundColor,
        width: `${widthPercentage}%`
      }
    },
    primaryColor() {
      return this.$store.state.clubMember?.club?.primaryColor
        ? `#${this.$store.state.clubMember.club.primaryColor}`
        : '#009F63';
    }
  },
  mounted() {
    this.init();
    this.setActiveTabFromRoute();
  },
  methods: {
    init() {
      if(this.$store.state.clubMember.rol === 'FOUNDER' || this.$store.state.clubMember.rol === 'ADMIN') {
        this.items.push({name: this.$t('dashboard_ClubMenu'), route: '/club', icon: 'fa-regular fa-home', admin: false});
      }
      if(this.items.length){
        this.items = [
          {...this.items[0]},
          //{name: this.$t('events'), route: '/club/events', icon: 'fa-regular fa-calendar-alt', admin: false},
          {name: this.$t('tournaments'), route: '/club/tournaments', icon: 'fa-regular fa-trophy', admin: false},
          // League tab hidden temporarily (under development)
          //{name: this.$t('league'), route: '/club/league', icon: 'fa-regular fa-swords', admin: false},
          {name: this.$t('members'), route: '/club/members', icon: 'fa-regular fa-users', admin: false},
        ];
      } else{
        this.items = [
          {name: this.$t('events'), route: '/club/events', icon: 'fa-regular fa-calendar-alt', admin: false},
          {name: this.$t('tournaments'), route: '/club/tournaments', icon: 'fa-regular fa-trophy', admin: false},
          // League tab hidden temporarily (under development)
          //{name: this.$t('league'), route: '/club/league', icon: 'fa-regular fa-swords', admin: false},
          {name: this.$t('members'), route: '/club/members', icon: 'fa-regular fa-users', admin: false},
        ];
      }
      // eslint-disable-next-line no-console
      console.log('rol', this.$store.state.clubMember.rol);
      if(this.$store.state.clubMember.rol === 'FOUNDER' || this.$store.state.clubMember.rol === 'ADMIN') {
        this.items.push({name: this.$t('performance_ClubMenu'), route: '/club/performance', icon: 'fa-regular fa-chart-bar', admin: true});
      }else {
        this.$router.push('/club/events');
      }
    },
    goToRoute(item, index) {
      this.activeTab = index;
      this.$router.push(item.route);
    },
    seePendingRequests() {
      this.pendingMembers = this.$store.state.clubMembers.filter((member) => member.rol === 'PENDING').length;
    },
    setActiveTabFromRoute() {
      const currentIndex = this.items.findIndex(item => item.route === this.$route.path);
      if (currentIndex >= 0) {
        this.activeTab = currentIndex;
      }
    }
  }
}
</script>

<style scoped lang="scss">
.club-menu {
  width: 100%;
  margin: 16px 0;

  .tabs {
    display: flex;
    position: relative;
    background-color: var(--v-lightGray-base);
    border-radius: 10px;
    width: 100%;

    * {
      z-index: 2;
    }

    input[type="radio"] {
      display: none;

      &:checked {
        & + label {
          color: white !important;

          .v-icon {
            color: white !important;
          }
        }
      }
    }

    .tab {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      height: 38px;
      font-size: 14px;
      font-weight: 600;
      color: var(--v-mainBlack-base);
      border-radius: 10px;
      cursor: pointer;
      transition: color 0.15s ease-in;
      font-family: "Avenir", sans-serif;
      padding: 0 16px;

      .v-icon {
        margin-right: 8px;
        font-size: 14px;
        color: var(--v-mainBlack-base);
        transition: color 0.15s ease-in;
      }

      .tab-label {
        white-space: nowrap;
      }
    }

    .glider {
      position: absolute;
      display: flex;
      height: 38px;
      background-color: var(--v-mainGreen-base);
      border-radius: 10px;
      z-index: 1;
      transition: 0.25s ease-out;
    }
  }
}

.theme--dark .club-menu {
  .tabs {
    background-color: #303740;

    .tab {
      color: var(--v-fullWhite-base);

      .v-icon {
        color: var(--v-fullWhite-base);
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }
}

.badge {
  background-color: #EF5350 !important;
  font-size: 12px !important;
  color: #FFFFFF;
  border-radius: 100%;
  width: 20px;
  height: 20px;
  padding-top: 1.5%;
}
</style>



